export type MaintenanceViewTranslation = {
  autoReload: string;
  backAt: string;
  fallbackMessage: string;
  notice: {
    manage: string;
    text: string;
  };
  title: string;
};

export const maintenanceViewTranslation: MaintenanceViewTranslation = {
  autoReload: 'Strona sama się odświeży, gdy skończymy.',
  backAt: 'Wracamy: {{date}}',
  fallbackMessage: 'Trwają prace serwisowe. Przepraszamy za utrudnienia.',
  notice: {
    manage: 'Zarządzaj',
    text: 'Tryb serwisowy do {{date}} — pozostali widzą przerwę techniczną',
  },
  title: 'Trwają prace serwisowe',
};
